/**
* DevExpress HTML/JS Reporting (viewer\widgets\signatureEditor.js)
* Version:  23.1.4
* Build date: Jul 18, 2023
* Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { Editor } from '@devexpress/analytics-core/analytics-widgets';
export class SignatureEditor extends Editor {
    getAvailableSignature(root) {
        var reportPreviewModel = root.reportPreviewModel;
        if (!reportPreviewModel) {
            reportPreviewModel = root;
        }
        return reportPreviewModel.reportPreview.signatures;
    }
}
